// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")
require("jquery-ui")
require("jquery-ui/ui/widgets/autocomplete")
require('jquery-ui/themes/base/menu.css');
require('jquery-ui/themes/base/theme.css');
require('jquery-ui/themes/base/autocomplete.css');
require("select2")
require("jquery-ui/ui/widgets/datepicker");
//require("select2-bootstrap-theme")
//require("select2/dist/js/i18n/ja")
require("jquery-ui/ui/widgets/mouse")
require("./jquery.tablesorter.combined.min.js")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import $ from 'jquery';
import jquery from 'jquery';
window.$ = window.jquery = jquery;
import 'bootstrap'
import '@fortawesome/fontawesome-free/js/all'
import '../src/application.scss'
import 'cocoon-js'
import 'select2'
import 'select2/dist/css/select2.css'
import 'jquery-ui/themes/base/menu.css'
import 'jquery-ui/themes/base/theme.css'
import 'jquery-ui/themes/base/autocomplete.css'
import '../src/tablesorter/theme.bootstrap.min.css'
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

// FullCalendarをグローバル変数としてwindowオブジェクトに登録
window.FullCalendar = { Calendar, dayGridPlugin, interactionPlugin };


// $.fn.select2.defaults.set("allowClear", true)    // 空にできるようにする
// $.fn.select2.defaults.set("placeholder", "")     // allowClear だけだとエラーになるため
// $.fn.select2.defaults.set("width", "100%")       // tdタグの中に入れたときにだんだん大きくなっていくのを防ぐ
// $.fn.select2.defaults.set("theme", "bootstrap")  // テーマの指定
document.addEventListener("turbolinks:load", function() {
  // if($(window).width() < 600){
  //   $("meta[name='viewport']").attr('content','width=device-width,initial-scale=0.4');
  // }else if($(window).width() > 1400){
  //   $("meta[name='viewport']").attr('content','width=device-width,initial-scale=0.8');
  // }else{
  //   $("meta[name='viewport']").attr('content','width=device-width,initial-scale=0.64');
  // }

  $(window).on("load orientationchange resize", function() {
    if(screen.width < 600){
      $("meta[name='viewport']").attr('content','width=device-width,initial-scale=0.4');
    }else if(screen.width < 1000){
      if(location.pathname.indexOf('restoration_work_report_new') >= 0 || location.pathname.indexOf('restoration_work_report_edit') >= 0){
        $("meta[name='viewport']").attr('content','width=device-width,initial-scale=0.64');
      }else{
        $("meta[name='viewport']").attr('content','width=device-width,initial-scale=0.8');
      }
    }else{
      $("meta[name='viewport']").attr('content','width=device-width,initial-scale=0.8');
    }
  });

  const initSelect2 = ($element, options = {}) => {
    if ($element.data("select2")) {
      return;
    }

    const $modal = $element.closest(".modal");
    if ($modal.length) {
      options.dropdownParent = $modal;
    }

    $element.select2(options);
  };

  $('.js-searchable').each(function () {
    initSelect2($(this), {
      tags: true,
      tokenSeparators: [',', ' ']
    });
  });

  $('.company-select-search').each(function () {
    initSelect2($(this));
  });

  $(document).on("shown.bs.modal", ".modal", function () {
    $(this).find('.company-select-search').each(function () {
      initSelect2($(this));
    });
  });

  $('.notifications').stop().animate({right: '20px', opacity:'1'},400);

  setTimeout(function(){
    $('.notifications').stop().animate({right: '-200px', opacity:'0'},400).fadeOut();
  },2000);
    

  $(function () {
    $(".report_submit_for_regular_cleaning").click(function () {
      const working_day_1 = $('[name="regular_cleaning_daily_report[working_day(1i)]"]').val();
      const working_day_2 = $('[name="regular_cleaning_daily_report[working_day(2i)]"]').val();
      const working_day_3 = $('[name="regular_cleaning_daily_report[working_day(3i)]"]').val();
      const working_day = working_day_1 + '/' + working_day_2 + '/' + working_day_3
      const contract_type = $('[name="regular_cleaning_daily_report[contract_type]"]').val();
      $("#working_day_hidden_for_regular_cleaning").val(working_day);
      $("#contract_type_hidden_for_regular_cleaning").val(contract_type)
    });
  });
  $(function () {
    $(".report_submit_for_spot_cleaning").click(function () {
      const working_day_1 = $('[name="spot_cleaning_daily_report[working_day(1i)]"]').val();
      const working_day_2 = $('[name="spot_cleaning_daily_report[working_day(2i)]"]').val();
      const working_day_3 = $('[name="spot_cleaning_daily_report[working_day(3i)]"]').val();
      const working_day = working_day_1 + '/' + working_day_2 + '/' + working_day_3
      $("#working_day_hidden_for_spot_cleaning").val(working_day);
    });
  });

  //コメントサジェスト用のAjaxリクエスト
  // $(function() {
    // const dataList = function(request, response) {
    //   $.ajax({
    //     url: '/daily_reports/regular_cleaning/auto_complete/' + request.term,
    //     dataType: 'json',
    //     type: 'GET',
    //     cache: true,
    //     success: function(data) {
    //       response(data);
    //     },
    //     error: function(XMLHttpRequest, textStatus, errorThrown) {
    //       response(['']);
    //     }
    //   });
    // }

    // $('.comment_content').autocomplete({
    //   source: dataList,
    //   autoFocus: true, // 自動的に先頭の項目にフォーカスするか
    //   delay: 300, // 入力してからサジェストが動くまでの時間(ms)
    //   minLength: 2 // 2文字入力しないとサジェストが動かない
    // })
  // });

  // 作業日報登録・更新のパーシャル処理
  $(document).on('change', '#property_master_id_select', function() {
    return $.ajax({
      type: 'GET',
      url: '/admin/work_types',
      data: {
        property_master_id: $(this).val()
      }
    }).done(function(data) {
      return $('#work_type_select').html(data);
    });
  });

  $(document).on('change', '#rental_property_master_id_select', function() {
    $.ajax({
      type: 'GET',
      dataTyep: 'Script',
      url: '/admin/rental_support_reports/change_room_selector',
      data: {
        property_master_id: $(this).val()
      }
    });
  });

  $(function () {
    $("#send_report_excel").click(function () {
      $("#type_hidden").val('excel');
    });
  });
  $(function () {
    $("#send_report_pdf").click(function () {
      $("#type_hidden").val('pdf');
    });
  });
  
  // お知らせ一覧の日付入力制御
  // datePickerMethod($("#search_start_date"), $("#search_end_date"))

  // // datePickerの用いた日付の範囲検索の入力制御の関数
  // function datePickerMethod(start_date, end_date){
  //   start_date.datepicker({
  //     changeYear: true,
  //     changeMonth: true,
  //     showButtonPanel: true,
  //     beforeShow : function(input) {
  //       setTimeout(function() {
  //           var buttonPane = $(input).datepicker('widget').find('.ui-datepicker-buttonpane');
  //           $('<button>', { text: 'クリア',
  //                           click: function() {
  //                             $.datepicker._clearDate(input);
  //                           }
  //                         }).appendTo( buttonPane ).addClass('ui-datepicker-clear ui-state-default ui-priority-secondary ui-corner-all');
  //       }, 1 );
  //     },
  //     onChangeMonthYear: function(year, month, instance) {
  //       setTimeout(function() {
  //            var buttonPane = $(instance).datepicker('widget').find('.ui-datepicker-buttonpane');
  //           $('<button>', {text: 'クリア',
  //                           click: function() {
  //                             $.datepicker._clearDate(instance.input);
  //                           }
  //                         }).appendTo( buttonPane ).addClass('ui-datepicker-clear ui-state-default ui-priority-secondary ui-corner-all');
  //       }, 1 );
  //     },
  //     onSelect: function (selectedDate) {
  //       end_date.datepicker("option", "minDate", selectedDate);
  //     }
  //   });
  //   // 動作実行前のDatetimeの日本語化設定
  //   $.datepicker.regional['ja'] = {
  //     closeText: '閉じる',
  //     prevText: '<前',
  //     nextText: '次>',
  //     currentText: '今日',
  //     monthNames: ['1月','2月','3月','4月','5月','6月',
  //     '7月','8月','9月','10月','11月','12月'],
  //     monthNamesShort: ['1月','2月','3月','4月','5月','6月',
  //     '7月','8月','9月','10月','11月','12月'],
  //     dayNames: ['日曜日','月曜日','火曜日','水曜日','木曜日','金曜日','土曜日'],
  //     dayNamesShort: ['日','月','火','水','木','金','土'],
  //     dayNamesMin: ['日','月','火','水','木','金','土'],
  //     weekHeader: '週',
  //     dateFormat: 'yy/mm/dd',
  //     firstDay: 0,
  //     isRTL: false,
  //     showMonthAfterYear: true,
  //     yearSuffix: '年'};
  //   $.datepicker.setDefaults($.datepicker.regional['ja']);
    
  //   start_date.change(function () {
  //     var v = this.value;
  //     if (v.length == 0) {
  //       end_date.datepicker("option", "minDate", new Date(1900, 0, 1));
  //      }
  //   });
  
  //   end_date.datepicker({
  //     changeYear: true,
  //     changeMonth: true,
  //     showButtonPanel: true,
  //     beforeShow : function(input) {
  //       setTimeout(function() {
  //           var buttonPane = $(input).datepicker('widget').find('.ui-datepicker-buttonpane');
  //           $('<button>', { text: 'クリア',
  //                           click: function() {
  //                             $.datepicker._clearDate(input);
  //                           }
  //                         }).appendTo( buttonPane ).addClass('ui-datepicker-clear ui-state-default ui-priority-secondary ui-corner-all');
  //       }, 1 );
  //     },
  //     onChangeMonthYear: function(year, month, instance) {
  //       setTimeout(function() {
  //            var buttonPane = $(instance).datepicker('widget').find('.ui-datepicker-buttonpane');
  //           $('<button>', {text: 'クリア',
  //                           click: function() {
  //                             $.datepicker._clearDate(instance.input);
  //                           }
  //                         }).appendTo( buttonPane ).addClass('ui-datepicker-clear ui-state-default ui-priority-secondary ui-corner-all');
  //       }, 1 );
  //     },
  //     onSelect: function (selectedDate) {
  //       start_date.datepicker("option", "maxDate", selectedDate);
  //     }
  //   });
   
    
  //   // 動作実行後のDatetimeの日本語化設定
  //   $.datepicker.regional['ja'] = {
  //     closeText: '閉じる',
  //     prevText: '<前',
  //     nextText: '次>',
  //     currentText: '今日',
  //     monthNames: ['1月','2月','3月','4月','5月','6月',
  //     '7月','8月','9月','10月','11月','12月'],
  //     monthNamesShort: ['1月','2月','3月','4月','5月','6月',
  //     '7月','8月','9月','10月','11月','12月'],
  //     dayNames: ['日曜日','月曜日','火曜日','水曜日','木曜日','金曜日','土曜日'],
  //     dayNamesShort: ['日','月','火','水','木','金','土'],
  //     dayNamesMin: ['日','月','火','水','木','金','土'],
  //     weekHeader: '週',
  //     dateFormat: 'yy/mm/dd',
  //     firstDay: 0,
  //     isRTL: false,
  //     showMonthAfterYear: true,
  //     yearSuffix: '年'};
  //   $.datepicker.setDefaults($.datepicker.regional['ja']);
  //   end_date.change(function () {
  //     var v = this.value;
  //     if (v.length == 0) {
  //       start_date.datepicker("option", "maxDate", new Date(2200, 0, 1));
  //     }
  //   })
  // }

  // 管理会社（オーナー）の担当者情報の表示切り替え
  $('#admin_master_property_form_management_company_master_id').select2().on('select2:select', function(){
    comp_person_info_display($(this), $('#owner_comp_mng_area'));
  });

  // 指定管理会社の担当者情報の表示切り替え
  $('#admin_master_property_form_designated_management_company_master_id').select2().on('change', function(){
    comp_person_info_display($(this), $('#designated_comp_mng_area'));
  });

  function comp_person_info_display(target, display_area){
    if(target.val().length){
      display_area.show();
    }else{
      display_area.hide();
    }
  }

  // var calendarEl = document.getElementById('calendar');

  // var calendar = new Calendar(calendarEl, {
  //   plugins: [dayGridPlugin], // 必要なプラグインを指定
  //   initialView: 'dayGridMonth', // 月表示
  // });

  // calendar.render();
})
